export const isServer = typeof window === "undefined";
export const STORAGE_AUTH_NAME = "remynd_ts";
